<template>
    <div class="materialList" ref="materialList" id="materialList">
        <el-empty v-if="equipmentList.length == 0" description="暂无数据"></el-empty>
        <el-row :gutter="50" type="flex" style="flex-wrap: wrap;" v-else>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(i, index) in equipmentList" :key="i + index + 'a'">
                <equipment-card
                    :equipment="i"
                    :image-prefix="imgurl"
                    @details="detailsHandle"
                    @action="toAppoint"
                />
            </el-col>
        </el-row>
        <el-row class="pagination-box">
            <el-pagination
            background
            v-if="total > 0"
            layout="total,prev, pager, next"
            :current-page="params.pageNum"
            :page-size="params.pageSize"
            :total="total"
            @current-change="changePageNum"
            ></el-pagination>
        </el-row>
    </div>
</template>

<script>
import { equipList } from "@/api/request";
import equipmentCard from "@/components/equipmentCard.vue";

export default {
    components: {
        equipmentCard
    },
    data() {
        return {
            imgurl: process.env.VUE_APP_FILE_API,
            equipmentList: [],
            params: {
                pageSize: 8,
                pageNum: 1,
                status: 1,
                isGrounding: 1,
                isCloudScene: 12,
            },
            total: 0,
        }
    },
    created() {
        this.getEquipList()
    },
    methods: {
        async getEquipList() {
            const res = await equipList(this.params)
            this.equipmentList = res.rows,
            this.total = res.total
        },
        changePageNum(value) {
            this.params.pageNum = value
            this.getEquipList()
        },
        detailsHandle(i) {
            this.$router.push({
                path: "/equipDetails",
                query: {
                    id: i.id,
                    type: this.$route.query.type ? this.$route.query.type : 0
                }
            });
        },
        // 未登录时进入登录页，成功后继续打开当前设备的预约页面
    toAppoint(i) {
      const appointRoute = this.$router.resolve({
        path: "/appointPage",
        query: {
          id: i.id,
          type: this.$route.query.type ? this.$route.query.type : 0,
        },
      }).route.fullPath;
      if(this.$store.getters.token) {
        this.$router.push(appointRoute);
        return;
      }
      this.$router.push({
        path: "/login",
        query: {
          redirect: appointRoute,
        },
      });
        }
    }
}
</script>

<style scope lang="scss">
.materialList {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 80%;
    min-height: 58vh;
    margin: 0 auto;
    padding: 15px 0;
}

.pagination-box {
    text-align: right;
}
</style>